import { INTERNAL_LINKS } from "@/lib/helpers/urls";
import type { Route } from "next";

const REFERRERS = [
  "landing-2k",
  "landing-larger-cluster",
  "landing-bare-metal",
  "landing-infiniband",
  "prices-2k",
  "buy-larger-cluster",
  "buy-custom-setup",
  "settings-verify-identity",
  "usage-request-higher-limit",
  "auth-sign-in-error",
] as const;

type Referrer = (typeof REFERRERS)[number];

export const CONTACT_PAGE_REFERRER_PARAM = "referrer";
export const CONTACT_PAGE_MESSAGE_PARAM = "message";

/** Shared sales-inquiry placeholder prompting for company, use case, and quantity. */
export const CONTACT_DETAILS_PLACEHOLDER =
  "My company is [company name] and our use case is [description]. We're looking for [number] [SKU] nodes." as const;

/**
 * Get the URL for the contact page with a referrer and optional pre-filled message
 * @param referrer - The referrer to add to the URL
 * @param message - Optional message to pre-fill in the contact form
 * @returns The URL for the contact page with the referrer
 */
export const getContactPageUrl = (
  referrer: Referrer,
  message?: string,
): Route => {
  const params = new URLSearchParams({
    [CONTACT_PAGE_REFERRER_PARAM]: referrer,
  });
  if (message) {
    params.set(CONTACT_PAGE_MESSAGE_PARAM, message);
  }
  return `${INTERNAL_LINKS.CONTACT}?${params.toString()}` as Route;
};
